/**
 * REZILIENT Framework — WMFKNJ.Theme
 * Brand: REZILIENT | Namespace: rz-
 */
(function (window, document) {
  'use strict';

  var STORAGE_THEME = 'rz-theme';
  var STORAGE_MODE = 'rz-mode';

  window.WMFKNJ = window.WMFKNJ || {};
  window.WMFKNJ.Utils = window.WMFKNJ.Utils || {};
  window.WMFKNJ.Animations = window.WMFKNJ.Animations || {};
  window.WMFKNJ.Popup = window.WMFKNJ.Popup || {};
  window.WMFKNJ.Feed = window.WMFKNJ.Feed || {};
  window.WMFKNJ.Product = window.WMFKNJ.Product || {};
  window.WMFKNJ.Cart = window.WMFKNJ.Cart || {};
  window.WMFKNJ.Header = window.WMFKNJ.Header || {};
  window.WMFKNJ.Background = window.WMFKNJ.Background || {};
  window.WMFKNJ.Story3D = window.WMFKNJ.Story3D || {};

  function getSavedMode() {
    try {
      var saved =
        localStorage.getItem('drip-noir-theme') ||
        localStorage.getItem(STORAGE_MODE) ||
        localStorage.getItem(STORAGE_THEME);
      if (!saved) {
        var legacy = localStorage.getItem('drift-mode') || localStorage.getItem('drift-theme');
        if (legacy === 'light' || legacy === 'dark') {
          saved = legacy;
          localStorage.setItem(STORAGE_MODE, legacy);
          localStorage.setItem(STORAGE_THEME, legacy);
          localStorage.setItem('drip-noir-theme', legacy);
        }
      }
      return saved;
    } catch (e) {
      return null;
    }
  }

  function applyMode(mode) {
    var isLight = mode === 'light';
    document.documentElement.setAttribute('data-rz-mode', mode);
    document.documentElement.setAttribute('data-theme', mode);
    document.documentElement.classList.toggle('rz-light-mode', isLight);
    document.querySelectorAll('.rz-header').forEach(function (el) {
      el.setAttribute('data-rz-mode', mode);
    });

    var metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.content = isLight ? '#ffffff' : '#000000';
    }
  }

  function persistMode(mode) {
    try {
      localStorage.setItem(STORAGE_THEME, mode);
      localStorage.setItem(STORAGE_MODE, mode);
      localStorage.setItem('drip-noir-theme', mode);
    } catch (e) {}
  }

  function dispatchModeChange(mode) {
    document.dispatchEvent(new CustomEvent('rz:theme:change', { detail: { mode: mode } }));
    document.dispatchEvent(new CustomEvent('rz:mode:change', { detail: { mode: mode } }));
  }

  function initMode() {
    if (initMode._done) return;
    initMode._done = true;

    var saved = getSavedMode();
    if (saved === 'light' || saved === 'dark') {
      applyMode(saved);
      persistMode(saved);
    } else {
      applyMode('dark');
      persistMode('dark');
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mode-toggle], .rz-dark-mode-toggle, .rz-header__mode-toggle');
      if (!toggle) return;
      e.preventDefault();
      WMFKNJ.Theme.toggle();
    });
  }

  WMFKNJ.Theme = {
    get: function () {
      return document.documentElement.getAttribute('data-rz-mode') || 'dark';
    },
    set: function (mode) {
      applyMode(mode);
      persistMode(mode);
      dispatchModeChange(mode);
    },
    toggle: function () {
      var next = this.get() === 'light' ? 'dark' : 'light';
      this.set(next);
    },
    init: initMode,
    applyMode: applyMode,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMode);
  } else {
    initMode();
  }
})(window, document);
